import "@/App.css";

// Components
import PromoBanner from "@/components/PromoBanner";
import FloatingRDVButton from "@/components/FloatingRDVButton";
import Navbar from "@/components/Navbar";
import HeroSection from "@/components/HeroSection";
import PortalSection from "@/components/PortalSection";
import ForWhoSection from "@/components/ForWhoSection";
import TransformationSection from "@/components/TransformationSection";
import MechanismSection from "@/components/MechanismSection";
import ProgramSection from "@/components/ProgramSection";
import JoySection from "@/components/JoySection";
import BlockagesSection from "@/components/BlockagesSection";
import TestimonialsSection from "@/components/TestimonialsSection";
import FrequenciesSection from "@/components/FrequenciesSection";
import Phase2Section from "@/components/Phase2Section";
import BonusSection from "@/components/BonusSection";
import ComparisonSection from "@/components/ComparisonSection";
import AboutSection from "@/components/AboutSection";
import PricingSection from "@/components/PricingSection";
import InclusionsSection from "@/components/InclusionsSection";
import FAQSection from "@/components/FAQSection";
import FinalCTASection from "@/components/FinalCTASection";
import Footer from "@/components/Footer";
import siteConfig from "@/config/siteConfig";

function App() {
  return (
    <div className="min-h-screen bg-background">
      <PromoBanner />
      <FloatingRDVButton />
      <div className={siteConfig.promo.enabled ? "pt-12" : ""}>
        <Navbar />
        <main>
          <HeroSection />
          <PortalSection />
          <ForWhoSection />
          <TransformationSection />
          <MechanismSection />
          <ProgramSection />
          <JoySection />
          <BlockagesSection />
          <TestimonialsSection />
          <FrequenciesSection />
          <Phase2Section />
          <BonusSection />
          <ComparisonSection />
          <AboutSection />
          <PricingSection />
          <InclusionsSection />
          <FAQSection />
          <FinalCTASection />
        </main>
        <Footer />
      </div>
    </div>
  );
}

export default App;
